import { dev } from "../features/network/ApiCall";
import swal from "sweetalert";
export const LogoutUser = () => {
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const isSSO = localStorage.getItem("isSSO");
  const isSSOList = isSSO;
  const isSSOJson = JSON.parse(isSSOList);

  var axios = require("axios");
  let data = {
    emailId: userDetailsJson?.emailId,
  };

  var axios = require("axios");
  var config = {
    method: "post",
    url: `${dev}/register/sso/logout`,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + userDetailsJson?.accessToken,
    },
    data: data,
  };
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      if (isSSOJson === true) {
        localStorage.removeItem("userDetails");
        localStorage.removeItem("otp");
        localStorage.removeItem("forgetpass");
        localStorage.removeItem("isSSO");
        localStorage.removeItem("URP");
        localStorage.removeItem("store");
        localStorage.removeItem("isSession");
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("userPhotoDetails");

        window.location.href = `${process.env.REACT_APP_URL}/login`;
      } else {
        localStorage.removeItem("userDetails");
        localStorage.removeItem("otp");
        localStorage.removeItem("forgetpass");
        localStorage.removeItem("isSSO");
        localStorage.removeItem("URP");
        localStorage.removeItem("store");
        localStorage.removeItem("isSession");
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("userPhotoDetails");
        window.location.href = "/login";
      }
    })
    .catch(function (error) {
      console.log(error.response);
      if (error.response?.status === 401) {
        window.location.href = "/login";
      }
    });
};
